import {Injectable} from '@angular/core';
import {Consent} from '../../../../_shared/model/consent.model';
import {Observable} from 'rxjs';
import {HttpClientService} from '../../../../_shared/services/http-client.service';
import {HelperService} from '../../../../_shared/services';

@Injectable()
export class CustomerService {
    constructor(private httpClient: HttpClientService, private helper: HelperService) {}

    public updateCustomerConsent(contractorId: number, customerId: number, consent: Consent): Observable<Consent> {
        return this.httpClient.put(
            this.helper.getApiUrl() + '/contractors/' + contractorId + '/customers/' + customerId + '/consent',
            consent,
        );
    }
}
